import { put, select, delay } from "redux-saga/effects";
import actions from "rdx/actions";
import { selectors } from "rdx";
import messages from "../messages";

const POLLING_INTERVAL = 2000;
const MAX_POLLING_ATTEMPTS = 30;

// Polls for an updated vision proposal count
function* pollVisionProposal({ projectId, initialCount }) {
  let attempts = 0;

  while (attempts < MAX_POLLING_ATTEMPTS) {
    try {
      yield put(actions.getVisionProposalCount({ id: projectId }));
      const currentCount = yield select(selectors.getVisionProposalsCount) || 0;
      const latestVisionProposal = yield select(selectors.selectLatestVisionProposal);
      const l2pProjectId = yield select(selectors.selectLeadToProposalDrawerProjectId);

      if (currentCount > initialCount) {
        if (projectId === l2pProjectId) {
          yield put(actions.setLeadToProposalDrawerProposalRequested());
          yield put(actions.updateL2pProjectDetails({ visionProposal: latestVisionProposal }));
        }
        return true;
      }

      // Wait before next attempt
      yield delay(POLLING_INTERVAL);
      attempts++;
    } catch (error) {
      yield put(
        actions.newErrorEvent({
          message: messages.ERROR_GETTING_VISION_PROPOSAL,
          error,
        }),
      );
    }
  }

  // Polling timeout error
  yield put(
    actions.newErrorEvent({
      message: messages.VISION_PROPOSAL_TIMEOUT,
      error: { messages: messages.VISION_PROPOSAL_TIMEOUT },
    }),
  );

  return false;
}

export default pollVisionProposal;
